import type { MissiveConversation } from "../types";

const INTERNAL_EMAIL_DOMAINS = ["choirmate.com"];

function isInternalEmail(email: string): boolean {
  const lowerEmail = email.toLowerCase();
  return INTERNAL_EMAIL_DOMAINS.some((domain) =>
    lowerEmail.endsWith(`@${domain}`)
  );
}

export function extractEmailFromConversation(
  conversation: MissiveConversation
): string | null {
  const candidateEmails: string[] = [];
  const latestMessage = conversation.latest_message;

  if (latestMessage) {
    if (latestMessage.from_field?.address) {
      candidateEmails.push(latestMessage.from_field.address);
    }
    if (latestMessage.to_fields) {
      for (const field of latestMessage.to_fields) {
        if (field?.address) candidateEmails.push(field.address);
      }
    }
    if (latestMessage.cc_fields) {
      for (const field of latestMessage.cc_fields) {
        if (field?.address) candidateEmails.push(field.address);
      }
    }
  }

  if (conversation.authors) {
    for (const author of conversation.authors) {
      if (author?.email) candidateEmails.push(author.email);
    }
  }

  for (const email of candidateEmails) {
    if (!isInternalEmail(email)) return email;
  }

  return null;
}
